export default __webpack_public_path__ + "static/media/sf6.9c381a90.jpeg";